import React from "react";
import {
    GamePlayPcHeaderBarFreePlayIndicatorBox
} from "../../../boxes/free-play/indicator/game-play-pc-header-bar-free-play-indicator.box";
import {
    IGameContextViewModel
} from "../../../../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {
    GamePlayPcHeaderBarAvailableVouchersListComponent
} from "../game-vouchers/game-play-pc-header-bar-available-vouchers-list.component";
import {bottom} from "@popperjs/core";
import {ITooltipViewModel} from "../../../../../../../../services/tooltip/tooltip-base/tooltip-view-model.interface";
import {
    IFreePlayVoucherViewModel
} from "../../../../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {CyClass} from "../../../../../../../../../common/cy-classes";
import {
    OrbitComponentWithState
} from "../../../../../../../base-components/orbit-component-with-state/orbit-component-with-state";

interface GamePlayPcHeaderBarFreePlayIndicatorComponentState {
    toolTip: ITooltipViewModel | null;
}

interface GamePlayPcHeaderBarFreePlayIndicatorComponentProps {
    gameContext: IGameContextViewModel;
}

export const GamePlayPcHeaderBarFreePlayIndicatorComponent = observer(
    class GamePlayPcHeaderBarFreePlayIndicatorComponent extends OrbitComponentWithState<GamePlayPcHeaderBarFreePlayIndicatorComponentProps, GamePlayPcHeaderBarFreePlayIndicatorComponentState> {

        constructor(props: GamePlayPcHeaderBarFreePlayIndicatorComponentProps) {
            super(props);
            this.state = {
                toolTip: null
            }
        }

        private _elementRef = React.createRef<HTMLDivElement>();

        private _setCurrentTooltip(toolTip: ITooltipViewModel | null): void {
            this.setState({
                toolTip: toolTip
            })
        }

        private _onVoucherClickHandler = async (voucher: IFreePlayVoucherViewModel) => {

            if(this.state.toolTip) {
                this.state.toolTip.closeTooltip();
                this._setCurrentTooltip(null);
            }


            await this.props.gameContext.controller.switchToFreePlay(voucher);
        }

        private get _isToolTipOpen(): boolean {
            return Boolean(this.state.toolTip);
        }

        private _onClickHandler = async () => {
            if(!this._elementRef.current) {
                return;
            }

            if(this.state.toolTip) {
                this._closeTooltip();
            } else {
                const tooltip = this.services.regularTooltips.showTooltip(
                    {
                        renderContent: () => (<GamePlayPcHeaderBarAvailableVouchersListComponent gameContext={this.props.gameContext}
                                                                                           onVoucherClick={this._onVoucherClickHandler}/>),
                        showCloseButton: true,
                        closeOnClickOutside: false,
                        attachTo: this._elementRef.current,
                        placement: bottom,
                        showOverlay: false,
                        animated: false,
                        zIndex: (await this.services.gameRunner).gameFrameZIndex + 1,
                        onTooltipClosed: () => {
                            this._setCurrentTooltip(null);
                        }
                    });

                this._setCurrentTooltip(tooltip);
            }
        }

        private _closeTooltip(): void {
            this.state.toolTip?.closeTooltip();
            this._setCurrentTooltip(null)
        }

        componentWillUnmount() {
            super.componentWillUnmount();
            this.state.toolTip?.closeTooltip();
        }

        render() {
            if(this.props.gameContext.company.isThirdPartyCompany) {
                //For 3rd party vouchers like Evolution the user doesn't have the option to accept or not the voucher
                //and the game goes straight to the free play if there is one.
                //In this case we don't show the free play indicator in the game header so the user can't switch to another
                //voucher during the game. The reason is that if his vouchers are consumed during this game session the client is not notified about that
                //because the 3rd party vouchers are not coming from firebase.
                return null;
            }

            const availableVouchers = this.props.gameContext.freePlayContext.otherAvailableVouchersForCurrentGame;

            if(availableVouchers.length === 0) {
                return null;
            }

            return (
                <GamePlayPcHeaderBarFreePlayIndicatorBox ref={this._elementRef}
                                                         onClick={this._onClickHandler}
                                                         isSelected={this._isToolTipOpen}
                                                         className={CyClass('cy-game-navbar-free-play-indicator')}/>
            )
        }
    }
);